import callAPiBase from './base';

const fareTaxApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/fareTaxList',
      method: 'GET',
      useToken: true,
      title: 'Fare Tax - Get List',
      params,
    }),
  getIntegrator: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/fareTaxIntegratorList',
      method: 'GET',
      useToken: true,
      title: 'Fare Tax Integrator - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/fareTaxCreate',
      method: 'POST',
      useToken: true,
      title: 'Fare Tax - Create',
      data,
    }),
  createIntegrator: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/fareTaxIntegratorCreate',
      method: 'POST',
      useToken: true,
      title: 'Fare Tax Integrator - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/fareTaxUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Fare Tax - Update',
      data,
    }),
  updateIntegrator: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/fareTaxIntegratorUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Fare Tax Integrator - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/fareTaxDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Fare Tax - Delete',
      params,
    }),
  deleteIntegrator: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/fareTaxIntegratorDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Fare Tax Integrator - Delete',
      params,
    }),
};

export { fareTaxApi };
export default fareTaxApi;
